import script from "./BasicInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&setup=true&lang=ts"

import "./BasicInfo.vue?vue&type=style&index=0&id=29225659&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29225659"]])

export default __exports__